var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctors06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375.206,
    height: 1298.921,
    viewBox: "0 0 375.206 1298.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.011,
    y1: 0.198,
    x2: 0.038,
    y2: 0.693,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0c499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#f1c69b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#f4cea4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.331,
    y1: -0.097,
    x2: 0.736,
    y2: 2.027,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d879f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#0f879f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#188aa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#278fa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c91a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.304,
    y1: -0.118,
    x2: 0.729,
    y2: 1.862,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.993,
    y1: 0.545,
    x2: 0.126,
    y2: 0.376,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.417,
    y1: 0.124,
    x2: 0.681,
    y2: 1.116,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e7dae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#2085b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#308cb9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.486,
    x2: 0.568,
    y2: 1.764,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a8ec9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#3f87c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#3580c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#337fc1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.594,
    y1: 1.047,
    x2: 0.229,
    y2: -0.572,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d879f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#1f8ca4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c91a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.422,
    y1: 1.018,
    x2: 0.687,
    y2: -0.12,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f6cb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopColor: "#2175bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#337fc1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.57,
    y1: 1.016,
    x2: 0.24,
    y2: -0.611,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.626,
    y1: 1.056,
    x2: 0.25,
    y2: -0.013,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.491,
    y1: 1.704,
    x2: 0.507,
    y2: -1.298,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.504,
    y1: -0.063,
    x2: 0.466,
    y2: 1.081,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -0.223,
    y1: 0.046,
    x2: 1.561,
    y2: 0.725,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1e1e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1.018,
    y1: 1.069,
    x2: -0.088,
    y2: 0.027,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#f8f8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.034,
    y1: 1.085,
    x2: 1.061,
    y2: 0.054,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.445,
    y1: 0.208,
    x2: 0.626,
    y2: 1.112,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.537,
    y1: 0.268,
    x2: 0.423,
    y2: 0.966,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1.283,
    y1: 0.507,
    x2: 0.067,
    y2: 0.496,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1.406,
    y1: -0.407,
    x2: 0.208,
    y2: 0.991,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.348,
    y1: 0.984,
    x2: 0.779,
    y2: 0.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1e1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f0f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.479,
    y1: 1.378,
    x2: 0.534,
    y2: -0.743,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 11.464,
    y1: 17.257,
    x2: 11.607,
    y2: 15.426,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 10.388,
    y1: 22.324,
    x2: 10.5,
    y2: 20.236,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 10.605,
    y1: 21.063,
    x2: 10.722,
    y2: 19.036,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0.501,
    y1: 0.532,
    x2: 0.523,
    y2: 1.786,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 0.501,
    y1: 0.534,
    x2: 0.55,
    y2: 1.872,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -0.031,
    y1: -0.562,
    x2: 0.7,
    y2: 0.893,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -0.381,
    y1: -0.075,
    x2: 1.356,
    y2: 1.47,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0.501,
    y1: 0.542,
    x2: 0.523,
    y2: 2.186,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 0.484,
    y1: 0.929,
    x2: 0.562,
    y2: -0.149,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 0.271,
    y1: 1.025,
    x2: 0.793,
    y2: -0.269,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0.662,
    y1: -0.173,
    x2: 0.397,
    y2: 1.076,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 0.567,
    y1: -0.081,
    x2: 0.339,
    y2: 1.798,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 0.032,
    y1: 0.836,
    x2: 0.702,
    y2: 0.355,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1.137,
    y1: 0.612,
    x2: -0.232,
    y2: 0.235,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -0.008,
    y1: 0.444,
    x2: 1.181,
    y2: 0.574,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 0.466,
    y1: 1.042,
    x2: 0.542,
    y2: 0.025,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 69.604,
    y1: 1.227,
    x2: 69.679,
    y2: 0.214,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -35.502,
    y1: -11.467,
    x2: -36.414,
    y2: -10.285,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7aaab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#b7babb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#cbcdce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#d2d4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#e1e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#dcdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#d0d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#bcbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7aaab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -19.693,
    y1: -14.838,
    x2: -18.897,
    y2: -14.838,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -32.621,
    y1: -6.492,
    x2: -32.224,
    y2: -7.37,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#305a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192,
    stopColor: "#2c537a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#254666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#234260"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 145.572,
    y1: 0.98,
    x2: 145.756,
    y2: 1.957,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9bbbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#c3c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcece"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 161.818,
    y1: 1.567,
    x2: 162.818,
    y2: 1.567,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2d4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dddfe0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -10.183,
    y1: 3.133,
    x2: -9.461,
    y2: 2.242,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 254.536,
    y1: 1.683,
    x2: 254.928,
    y2: 3.149,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 298.147,
    y1: 2.08,
    x2: 298.194,
    y2: 3.31,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#eceded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f1f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 0.563,
    y1: 1.734,
    x2: 0.433,
    y2: -0.542,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#fdfdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 0.565,
    y1: 1.73,
    x2: 0.433,
    y2: -0.553,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -0.655,
    y1: -0.785,
    x2: 2.064,
    y2: 2.595,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 0.789,
    y1: -0.234,
    x2: -0.573,
    y2: 3.228,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 0.339,
    y1: 1.779,
    x2: 0.666,
    y2: -0.658,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 0.678,
    y1: 15.216,
    x2: 1.674,
    y2: 15.216,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 0.366,
    y1: 1.764,
    x2: 0.669,
    y2: -0.532,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -0.322,
    y1: -9.283,
    x2: 0.677,
    y2: -9.283,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 0.594,
    y1: 1.032,
    x2: 0.515,
    y2: 0.596,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#daa279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#e3af85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c498"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 72.364,
    y1: 13.455,
    x2: 73.722,
    y2: 14.429,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dba379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#e3b086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 822.968,
    y1: -20.656,
    x2: 824.573,
    y2: -19.69,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 0.517,
    y1: 1.025,
    x2: 0.473,
    y2: 0.373,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#f5d1a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#f2c99f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 0.519,
    y1: 1.039,
    x2: 0.476,
    y2: 0.391,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.52,
    cy: 0.492,
    r: 0.59,
    gradientTransform: "translate(0.248 0.071) scale(0.949 1.013)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8c39c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.418,
    cy: 0.5,
    r: 0.595,
    gradientTransform: "translate(0.307 0.07) scale(0.936 1.013)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 0.992,
    y1: 0.265,
    x2: 0.017,
    y2: 0.943,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd6af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 0.528,
    y1: 2.461,
    x2: 0.492,
    y2: -0.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#f6d1a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#f2c99f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1c59a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 0.548,
    y1: 2.503,
    x2: 0.494,
    y2: -0.051,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 0.558,
    y1: 2.544,
    x2: 0.493,
    y2: -0.058,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 0.532,
    y1: 8.116,
    x2: 0.488,
    y2: -1.634,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -0.062,
    y1: 0.433,
    x2: 1.139,
    y2: 0.537,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d9d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#efe5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#faf8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8d3d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 0.533,
    y1: 4.784,
    x2: 0.5,
    y2: 0.118,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 0.493,
    y1: -0.896,
    x2: 0.508,
    y2: 1.092,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d9d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#efe5e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 0.515,
    y1: 12.008,
    x2: 0.497,
    y2: -2.072,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 1.046,
    y1: 0.87,
    x2: -0.381,
    y2: 0.114,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 0.042,
    y1: 0.273,
    x2: 0.968,
    y2: 0.758,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0c499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#e3b086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dba379"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 0.955,
    y1: 0.731,
    x2: 0.183,
    y2: 0.333,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ece7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#f5f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 1.001,
    y1: 0.474,
    x2: -0.372,
    y2: 0.544,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#936655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a3d32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 0.496,
    y1: 0.927,
    x2: 0.774,
    y2: 3.708,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a3d32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#936655"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.945,
    cy: 0.812,
    r: 1.454,
    gradientTransform: "translate(0.267 0.314) scale(0.987 1.013)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c2727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -0.014,
    y1: 0.543,
    x2: 0.956,
    y2: 0.381,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#281b18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#2c1e1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#382723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c2a25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 0.008,
    y1: 0.244,
    x2: 1.006,
    y2: 0.768,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 0.991,
    y1: 0.74,
    x2: 0.159,
    y2: 0.312,
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 1.002,
    y1: 0.477,
    x2: -0.375,
    y2: 0.547,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 0.492,
    y1: 0.889,
    x2: 0.76,
    y2: 3.581,
    xlinkHref: "#linear-gradient-73"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.945,
    cy: 0.812,
    r: 1.454,
    gradientTransform: "translate(0.274 0.314) scale(0.987 1.013)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -0.01,
    y1: 0.623,
    x2: 0.954,
    y2: 0.461,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 0.987,
    y1: 1.12,
    x2: -0.077,
    y2: 0.171,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6d2aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c498"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 0.078,
    y1: 1.134,
    x2: 1.063,
    y2: 0.166,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6d2aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd8b2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 0.41,
    y1: -0.674,
    x2: 0.505,
    y2: 0.954,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#fcd7b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: -8.879,
    y1: -20.631,
    x2: -8.883,
    y2: -22.264,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 0.483,
    y1: -0.964,
    x2: 0.511,
    y2: 1.16,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 0.458,
    y1: 1.068,
    x2: 0.593,
    y2: -0.197,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#fbd6af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 0.433,
    y1: -0.619,
    x2: 0.5,
    y2: 0.82,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#f3caa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 0.46,
    y1: -0.406,
    x2: 0.516,
    y2: 0.922,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c2a25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#352520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#2b1d1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281b18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 0.531,
    y1: 1.549,
    x2: 0.463,
    y2: 0.068,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#281b18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#2b1d1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#352520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c2a25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 0.353,
    y1: 0.02,
    x2: 0.69,
    y2: 1.654,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c3633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#402d28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c2a25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 0.473,
    y1: -0.886,
    x2: 0.523,
    y2: 1.613,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 0.49,
    y1: 1.494,
    x2: 0.504,
    y2: 0.058,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#fbd6af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd9b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 0.502,
    y1: -1.984,
    x2: 0.498,
    y2: 1.646,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.498,
    cy: 0.485,
    r: 3.799,
    gradientTransform: "translate(4.066 262.852) scale(0.112 0.124)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e3e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#eae9e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#fbfaf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefdfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 0.36,
    y1: -0.063,
    x2: 0.515,
    y2: 1.097,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#cbdaf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0def6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 55.438,
    y1: 1.75,
    x2: 55.438,
    y2: 0.492,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#0f0f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b0b0c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 302.724,
    y1: 0.444,
    x2: 306.012,
    y2: 2.615,
    xlinkHref: "#linear-gradient-97"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 75.974,
    y1: 2.536,
    x2: 76.017,
    y2: 6.757,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#201e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c1a1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 85.845,
    y1: 1.851,
    x2: 84.715,
    y2: 4.184,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282829"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 74.571,
    y1: 2.558,
    x2: 74.571,
    y2: 1.3,
    xlinkHref: "#linear-gradient-97"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 413.614,
    y1: 3.142,
    x2: 416.902,
    y2: 5.313,
    xlinkHref: "#linear-gradient-97"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 101.956,
    y1: 8.913,
    x2: 102,
    y2: 13.134,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 115.168,
    y1: 4.933,
    x2: 114.038,
    y2: 7.266,
    xlinkHref: "#linear-gradient-100"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    y1: 0.5,
    x2: 2.242,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b2b2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 0.584,
    y1: 0.104,
    x2: 0.222,
    y2: 1.694,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 0.49,
    y1: 1.388,
    x2: 0.514,
    y2: 0.375,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 0.515,
    y1: -0.94,
    x2: 0.498,
    y2: 1.004,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#1c1c1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: -0.017,
    y1: 0.536,
    x2: 1.132,
    y2: 0.472,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: -0.159,
    y1: 0.482,
    x2: 0.886,
    y2: 0.506,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#3a3a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: -0.126,
    y1: 0.071,
    x2: 1.687,
    y2: 1.607,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: -0.019,
    y1: 0.09,
    x2: 1.828,
    y2: 1.547,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: -0.201,
    y1: 0.054,
    x2: 1.551,
    y2: 0.721,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: -0.274,
    y1: 0.076,
    x2: 1.246,
    y2: 1.638,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: -0.672,
    y1: -0.777,
    x2: 2.104,
    y2: 2.572,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 0.791,
    y1: -0.233,
    x2: -0.607,
    y2: 3.214,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 88.687,
    y1: 1.276,
    x2: 89.171,
    y2: -0.685,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 0.663,
    y1: 14.52,
    x2: 1.659,
    y2: 14.52,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: -0.007,
    y1: 0.946,
    x2: 0.486,
    y2: -1.038,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: -0.315,
    y1: -8.841,
    x2: 0.683,
    y2: -8.841,
    xlinkHref: "#linear-gradient-13"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doctors_06",
    "data-name": "Doctors 06",
    transform: "translate(2150.881 -4691.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    d: "M-2035.91,4904.86s-2.564-20.443,29.656-25.569,79.081-5.857,84.938,16.842S-2035.91,4904.86-2035.91,4904.86Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    d: "M-2022.61,4888.2c-10.4,5.4-2.058-2.246-4.758-1.434,0,0,19.357-12.6,50.16-12.357,30.506.244,47.332,8.2,51.987,14.4-.653-.871-.444,3.815-1.862,1.985-1.269-1.641-6.347-4.55-9.853-5.892-10.306-3.938-26.345-5.891-38.566-5.37C-1996.5,4880.43-2003.81,4878.44-2022.61,4888.2Z",
    fill: "#fcfefe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    d: "M-2048.24,4912.81s22.946-6.716,27.424-12.874c0,0,58.064,19.378,82.686-3.006l24.206,11.4s-27.3,78.592-65.36,78.087C-2044.68,4985.56-2048.24,4912.81-2048.24,4912.81Z",
    fill: "#f7d9ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    d: "M-2019.41,4882.38l-3.091,38.272s-8.465,48.837,53.456,71.355c0,0,31.512-35.273,33.288-40.016s-3.358-61-6.62-74.052Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    d: "M-1860.5,5249.56h-221.97c-.689,5.378-1.355,12.578-2,21.2h225.906C-1859.66,5258.66-1860.5,5249.56-1860.5,5249.56Z",
    fill: "#276cac"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2585",
    "data-name": "Path 2585",
    d: "M-1934.63,4897.7c-1.279-.961-2.562-9.228-3.423-17.084-.608-10.337-1.306-21.785-1.507-23.606,0,0-29.766,21.482-81.888,3.355,0,0,.031,17.178.24,31.509-.2,3.253-.394,4.765-.656,6.6-.559,3.918-30.12,15.844-30.12,15.844s22.5,72.478,73.423,75.836,75.249-77.239,75.249-77.239S-1932.39,4899.38-1934.63,4897.7Zm-44.5,61.409-52.712-46.3s11.031-2.794,13.268-3.915c1.531-.764,2.465-3.555,3.037-6.528,12.787,11.792,27.633,18.857,36.136,18.085,9.4-.854,23.882-7.638,34.615-15.684l18.308,4.254c-7.942,16.479-52.662,50.088-52.662,50.088Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2586",
    "data-name": "Path 2586",
    d: "M-1870.51,5044.83c-.385-5.763,1.99-13.575,3.964-22.287h11.635c3.134-19.971,5.574-48.385,6.993-67.389,1.2-3.877,1.923-6.156,1.923-6.156-.373-.272-.852-.579-1.41-.912.567-8.047.872-13.176.872-13.176-9.779-7.113-61.012-25.786-61.012-25.786-4.225,3.352-72.388,58.711-72.388,58.711l-62.776-58.711c-81.367,32.663-70.7,29.565-70.7,29.565,1.694,3.4,5.26,55.213,10.011,83.854h9.052c2.328,13.822,4.377,24.807,4.319,26.744-1.745,57.907-2.644,135.762,4.346,221.47h225.114C-1864.12,5196.47-1865.25,5123.49-1870.51,5044.83Z",
    fill: "#337fc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2587",
    "data-name": "Path 2587",
    d: "M-2086.64,5184.32l-2.27,49.935,8.4,36.5h14.035C-2073.6,5252-2081.36,5224.19-2086.64,5184.32Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    d: "M-1862.71,5232.81l-6.718-54.758a204.7,204.7,0,0,1-14.717,92.7h11.059Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M-1988.26,4929.67l13.331,16,12-18.667-16,8Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M-1998.51,5207.61l21.178,8.516,10.446-29.323,20.99-10.292,1-25.812-49.39,6.5Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M-2066.47,4977.7c28.6-16.828,44.234,3.7,88.817,4.96s74.116-22.872,90.1-6.882,9.731,82.25-79.934,88.345C-2072.87,5071.28-2095.08,4994.53-2066.47,4977.7Z",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M-2090.34,5023.79c-.558-8.384-4.388-27.23-1.854-24.1s1.679,9.1,6.27,26.984c2.664,10.375,6.308,23.705,11.175,39.925,3.379,11.263-17.512,90.054-17.512,90.054s.841-26.247,1.025-46.31C-2091.15,5100.93-2087.73,5062.99-2090.34,5023.79Z",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M-1933.28,4935.46l-11.219,6.223s-16.526,51.41-18.424,57.667-3.678,48.428-3.932,58.081,1.017,45.982,1.017,45.982l15.661,120.383,6.038,46.96h19.275Z",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    d: "M-1869.61,5026.85c.434-9.353,2.209-23.1.828-26.873s-1.134,8.429-5.437,26.549c-2.411,10.153-5.817,23.347-10.576,39.805-3.266,11.3,20.054,87.306,20.054,87.306s-1.147-17.764-1.695-37.587C-1866.69,5106.85-1871.4,5065.37-1869.61,5026.85Z",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    d: "M-1991.52,5233.42c.6-8.13,7.9-125.466,7.9-125.466s-10.028-107.494-10.458-113.213-15.7-53.122-15.7-53.122l-12.338-11.539,1.7,340.668h24.882C-1993.43,5251.88-1991.73,5236.31-1991.52,5233.42Z",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M-1994.29,5079.48l35.494-.711-3.2,21.776-31.157-.493Z",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M-2054.3,4913.78l11.594-4.663,62.776,58.71,72.388-58.71,12.516,4.675-82.627,68.866Z",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M-2113.43,4936.67s75.994-27.768,83.788-31.665l36.821,156.793,1.842,18.031,1.634,30.43-82.678-6.5s-6.09-56.022-8.04-61.38S-2111.48,4940.56-2113.43,4936.67Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    d: "M-1856.02,5166.44l-94.164,2.271,11.02,102.039h99.591C-1848.45,5214.85-1856.02,5166.44-1856.02,5166.44Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M-1992.18,5172.12l-98.409-3.408s-6.325,47.269-13.659,102.042h102.884Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M-1989.63,5154.32l-99.9,4.391-2.838,23.557s42.6,5.791,52.834,9.689c5.973,2.277,30.891,12.147,43.946,16.688Z",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2602",
    "data-name": "Path 2602",
    d: "M-1925.36,4900.91s73.53,26.414,85.221,29.338c0,0-21.286,85.231-26.8,111.07a425.425,425.425,0,0,0-7.792,59.433l-86.8,8.366-.756-47.114Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M-1925.36,4900.91l86.544,29.5S-1886.88,4926.73-1925.36,4900.91Z",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    d: "M-2113.43,4936.09l87.9-34.355S-2068.34,4936.83-2113.43,4936.09Z",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2605",
    "data-name": "Path 2605",
    d: "M-1927.13,5070.29c-12.989,5.994-22.523,8.08-34.9,7.585.048,3.358-.119,26.885-.26,29.771l38.085,2.591,40.921-40.92,4.384-36.049S-1913.82,5064.15-1927.13,5070.29Z",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2606",
    "data-name": "Path 2606",
    d: "M-1990.99,5079.12c-17.8-.713-84.226-32.211-84.226-32.211l5.845,41.9,80.03,11.23C-1988.49,5097.54-1990.8,5083.3-1990.99,5079.12Z",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2607",
    "data-name": "Path 2607",
    d: "M-1858.29,5148.28l-94.912,2.65c.946,7.189,3.311,19.275,4.091,27.5l12.379-7.413s59.864,7.341,82.273,5.391Z",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2608",
    "data-name": "Path 2608",
    d: "M-1901.8,5084.42a553.865,553.865,0,0,0,26.307-74.533c11.177-41.66,27.649-79.024,36.565-79.151l-27.8,128.842Z",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2609",
    "data-name": "Path 2609",
    d: "M-1809.73,5090.65c.96-17.03-12.62-70.009-13.012-76.889s-8.456-81.884-16.181-83.03-25.217,60.5-25.848,62.59c-2.66,8.788-13.719,66.541-13.719,66.541l5.439,37.324c11.088,1.048,23.435,0,30.4,9.974,11.657,15.765,17.749,35.341,19.371,54.984.472-.07.853-.135,1.121-.194C-1817.18,5160.91-1810.69,5107.68-1809.73,5090.65Z",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2610",
    "data-name": "Path 2610",
    d: "M-1971.22,5169.92s42.279-14.247,52.262-19.51,48.219-43.808,50.569-45.564,23.026-14.907,24.384-16.5,2.38-7.866-2.516-7.794c0,0,8.52-1.732,10.487-2.407,2.922-1.006,9.317-9.11-5.348-9.134,0,0,6.641-2.622,4.345-7.218s-14.461-3.177-18.185-2.516-22.441,5.179-22.441,5.179,21.17-8.6,23.809-12.643c2.151-3.287.338-6.816-5.306-6.561s-19.856,6.375-21.636,7.2-12.477,8.719-13.773,9.583-37.515,41.544-37.515,41.544l-38.966,49.973Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2611",
    "data-name": "Path 2611",
    d: "M-1929.93,5100.25l9.863-10.117s12.789,3.9,45.308,2.809c7.3-.246,18.268,0,19.73-.366s11.96-4.558,11.722-10.208a5.464,5.464,0,0,1-.7,5.98c-3.151,4.029-17.238,11.537-17.238,11.537Z",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2612",
    "data-name": "Path 2612",
    d: "M-1863.75,5046.24s-1.887,5.293,3.383,5c2.98-.164.614.1,3.909-.673s2.28-6.049-.257-6.026a14,14,0,0,0-7.035,1.7Z",
    fill: "#f7dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2613",
    "data-name": "Path 2613",
    d: "M-1847.91,5059.26s-3.216,4.969,2.277,5.949c3.111.556.612.258,4.191.26s3.8-5.645,1.189-6.243a14.863,14.863,0,0,0-7.657.035Z",
    fill: "#f7dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2614",
    "data-name": "Path 2614",
    d: "M-1852.38,5083.26s-.67,4.422,3.637,3.343c2.438-.609.526-.017,3.119-1.157s.87-5.071-1.223-4.647A12.161,12.161,0,0,0-1852.38,5083.26Z",
    fill: "#f7dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2615",
    "data-name": "Path 2615",
    d: "M-1898.74,5076.68s20.24-12.012,26.219-13.971,13.717-7.047,13.717-7.047,4.991-2.612,5.6-4.371a4.763,4.763,0,0,0,.1-3.061s.3.921-1.575,2.511-11.938,6.5-13.787,7.908-7.683,2.279-9.457,3.145S-1898.74,5076.68-1898.74,5076.68Z",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2616",
    "data-name": "Path 2616",
    d: "M-1836.81,5065.03s-1.462,3.336-3.409,3.776c-1.992.448-9.809,1.566-12.08,2s-15.07,2.389-15.662,2.678-19.844,13.172-19.844,13.172,15.162-13.989,17.71-15.12S-1839.96,5067.92-1836.81,5065.03Z",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2617",
    "data-name": "Path 2617",
    d: "M-1832.29,5074.15a7.4,7.4,0,0,1-4.288,4.455c-3.5,1.148-12.252,2.31-13.386,2.523s-14.851,6.34-16.759,6.82-15.588,9.14-15.588,9.14,11.267-9.908,14.639-11.665,12.8-6.014,15.861-6.888S-1837.99,5078.17-1832.29,5074.15Z",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2618",
    "data-name": "Path 2618",
    d: "M-1894.43,5074.17s16.525-9.651,18.577-10.211c8.031-2.2,17.566-4.036,17.566-4.036s-11.965,3.917-16.35,5.984S-1894.43,5074.17-1894.43,5074.17Z",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2619",
    "data-name": "Path 2619",
    d: "M-1917.3,5087.05s20.138-22.968,21.963-24.673,12.472-8.692,14.369-9.978,13.9-5.275,13.9-5.275-10.847,5.266-13.04,6.362-12.787,9.255-14.128,10.354S-1917.3,5087.05-1917.3,5087.05Z",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2620",
    "data-name": "Path 2620",
    d: "M-1843.19,5069.65s-2.53,5.282,2.878,5.545c3.063.149.616.174,4.07-.28s3.018-6.021.431-6.271a14.287,14.287,0,0,0-7.379,1.006Z",
    fill: "#f7dcbb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2621",
    "data-name": "Path 2621",
    d: "M-1974.87,5172.59l38.729-13.882-40.436-7.065Z",
    fill: "#efc399"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2622",
    "data-name": "Path 2622",
    d: "M-2053.3,5086.85s-23.382-66.252-33.613-103.274c-1.8-6.523-12.852-48.4-24.924-48.121l37.589,152.856Z",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M-2110.6,4935.43c5.007,1.278,13.966,22.585,18.846,42.8,3.976,16.476,12.636,71.6,15.073,83.78,2.922,14.616,5.388,38.981,5.388,38.981l113.171,35.943s-10.751,40.154-13.554,47.251-7.685,21.344-7.685,21.344-64.043-23.053-76.959-26.352-70.858-11.9-70.858-11.9-16.364-2.815-12.1-78.721c1.294-23.086,7.5-53.235,8.036-70.881,1.462-48.228,7.217-67.248,8.584-70.871C-2120.28,4940.5-2114.91,4934.33-2110.6,4935.43Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M-2084.42,5017.17s13.465,43.981,13.831,46.539.365,19.364.365,19.364l-10.23,18.271,24.113,16.439,32.517,4.019,65.024,19.2-6.666,22.653-15.983-2.75s-2.923-8.038-4.384-13.885c-12.058-4.385-45.306-13.882-50.421-14.248s-26.67-6.21-41.284-17.173c-3.533-2.648-37.348,6.021-33.614.731C-2102.38,5103.9-2075.17,5088.78-2084.42,5017.17Z",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2625",
    "data-name": "Path 2625",
    d: "M-1971.68,5140.91s-49.31-15.2-52.525-16.205-7.829,1.533-10.378,1.318-23.051-4.9-24.445-5.748-24.243-16.732-25.243-17.917,6.473-26.948,18.121-25.958c9.491.808,27.631,9.685,30.422,11.39s33.359,8.707,36.668,8.621,25.907,1.473,25.907,1.473Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2626",
    "data-name": "Path 2626",
    d: "M-1979.93,5138.61l4.134,18.589s6.527-14.812,6.285-17.736Z",
    fill: "#dbd8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2627",
    "data-name": "Path 2627",
    d: "M-2049.76,5081.19s10.892,4.541,14.033,6.6c5.676,2.272,32.729,8.438,33.826,8.438s17.354.916,17.354.916l1.336,3.386s-16.865.084-18.69-.282-32.884-9.135-33.98-9.5S-2049.76,5081.19-2049.76,5081.19Z",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M-2085.57,5103.17s4.053-15.051,8.039-20.46c5.112-6.941,10.291-7.206,16.139-5.45,0,0-6.277,1.431-9.929,4.353s-6.21,4.019-6.21,6.213-2.193,2.921-2.559,5.845,1.826,5.115,5.845,9.133,14.615,13.518,18.269,13.882,19.641,2.446,28.5,3.291c7.674.73,52.982,6.52,52.982,6.52l3.282,15.373s-51.119-16.47-53.3-16.817-9.5,2.061-10.274,1.866c-1.89-.479-22.959-5.715-25.209-6.577C-2061.61,5119.73-2085.57,5103.17-2085.57,5103.17Z",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M-1985.11,5097.1l6.505.043s9.133,34.709,5.663,41.466l-7.124-2.009S-1975.8,5122.68-1985.11,5097.1Z",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2630",
    "data-name": "Path 2630",
    d: "M-1872.94,5097.98l-107.974-.881c1.374,1.094,10.915,49.184,5.153,60.085,20.862,2.251,42.611,4.681,51.369,5.35,54.21,4.152,92.865.861,101.11-.393a92.814,92.814,0,0,0-17.868-56.78C-1848.11,5095.39-1872.94,5097.98-1872.94,5097.98Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2631",
    "data-name": "Path 2631",
    d: "M-1823.24,5015.49c.728,36.171-1,42.8-12.424,21.921-10.595-19.364-30.872-79.143-4.476-107.163C-1827.63,4926.7-1823.24,5015.49-1823.24,5015.49Z",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2632",
    "data-name": "Path 2632",
    d: "M-2113.43,4936.09c2.537-.794,13.368,9,16.29,35.31s-9.256,91.582-19,95.479-12.4-33.818-14.831-44.534,3.843-59.864,5.846-68.413C-2123.18,4945.63-2120.47,4938.29-2113.43,4936.09Z",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2633",
    "data-name": "Path 2633",
    d: "M-2139.73,5124.42s.793,41.652,13.169,43.31,33,5.237,33,5.237l32.228,5.094s-53.84-14.968-59.321-17.525S-2139.33,5134.44-2139.73,5124.42Z",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2634",
    "data-name": "Path 2634",
    d: "M-1813.16,5123.33s-3.138,38.625-8.9,39.13c-85.676,7.489-153.717-5.278-153.717-5.278s1.6-3.317,1.827-9.774c92.073,9.5,135.387,4.284,143.276.337C-1818.46,5141.64-1813.16,5123.33-1813.16,5123.33Z",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2635",
    "data-name": "Path 2635",
    d: "M-1981.05,5097.03s120.445.715,122.733,1.025c27.04,3.654,37.269,19.365,10.234,24.479-30.417,5.756-127.147,0-127.147,0S-1977.96,5105.58-1981.05,5097.03Z",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2636",
    "data-name": "Path 2636",
    d: "M-1956.46,5014.26l41.006-105.439s16.107,28.31,21.479,29.775c0,0-19.038,3.417-24.9,3.417l21.477,17.085s-46.964,35.777-64.6,118.651Z",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2637",
    "data-name": "Path 2637",
    d: "M-1999.42,5025l-38.585-115.032s-16.476,28.1-21.866,29.492c0,0,18.99,3.668,24.847,3.746l-21.7,16.8s44.487,43.337,65.678,117.886Z",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2638",
    "data-name": "Path 2638",
    d: "M-2037.95,4989.04s13.619,57.38-22,58.988c0,0-1.856,3.075,3.3,3.235s34.143-7.683,22.514-63.02Z",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2639",
    "data-name": "Path 2639",
    d: "M-2055.27,4993.94s16.665,56.572,48.386,40.28c0,0,3.134,1.749-1.26,4.449s-33.448,10.28-50.824-43.53Z",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2640",
    "data-name": "Path 2640",
    d: "M-2009.6,5035.6s3.286-3.518,4.4-3,2.715,4.855,2.256,5.56-3.971,1.089-5.341.833a13.654,13.654,0,0,1-1.315-3.393Z",
    fill: "#234260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2641",
    "data-name": "Path 2641",
    d: "M-2054.76,5050.66s-4.1,2.515-5.044,1.709-1.317-5.4-.688-5.956,4.122.012,5.372.626A13.548,13.548,0,0,1-2054.76,5050.66Z",
    fill: "#234260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2642",
    "data-name": "Path 2642",
    d: "M-2036.11,4899.17c-19.833,14.1-22.895,45.73-20.785,60.087-13.318,6.718-2.887,37.514-2.439,37.7s5.034-1.338,5.374-1.948-11.953-29.257.1-31.434c13.209-2.38,15.251,27.984,15.5,28.469s5.848-.389,6.183-1-4.98-32.255-20.792-32.461c-1.566-11.893-.5-36.137,14.37-52.518C-2038.45,4905.28-2035.89,4899.76-2036.11,4899.17Z",
    fill: "url(#linear-gradient-41)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2643",
    "data-name": "Path 2643",
    d: "M-1928.26,5005.36a15.971,15.971,0,0,0,15.717,16.226,15.968,15.968,0,0,0,16.134-15.8,15.973,15.973,0,0,0-15.715-16.228,15.977,15.977,0,0,0-16.136,15.8Z",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2644",
    "data-name": "Path 2644",
    d: "M-1926.25,5004.85a14.327,14.327,0,0,0,14.1,14.551,14.321,14.321,0,0,0,14.473-14.173,14.324,14.324,0,0,0-14.092-14.554,14.326,14.326,0,0,0-14.476,14.177Z",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2645",
    "data-name": "Path 2645",
    d: "M-1907.61,4989.91c8.426-40.442,10.2-84.878-12.5-93.055a17.119,17.119,0,0,0,1.4,4.639c20.32,12.14,11.163,68.736,7.013,88-.391,1.911-1.9,4.182-1.628,6.656s3.5,3.413,4.744,1.374S-1907.93,4991.37-1907.61,4989.91Z",
    fill: "url(#linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2646",
    "data-name": "Path 2646",
    d: "M-1919.35,5004.61a9.139,9.139,0,0,0,9.7,8.529,9.13,9.13,0,0,0,8.427-9.79,9.132,9.132,0,0,0-9.7-8.525,9.134,9.134,0,0,0-8.427,9.786Z",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2647",
    "data-name": "Path 2647",
    d: "M-1917.34,5003.72a7.728,7.728,0,0,0,8.28,7.116,7.7,7.7,0,0,0,5.3-2.6,7.692,7.692,0,0,0,1.9-5.584,7.729,7.729,0,0,0-8.279-7.111,7.693,7.693,0,0,0-5.3,2.593,7.691,7.691,0,0,0-1.9,5.582Z",
    fill: "url(#linear-gradient-46)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2648",
    "data-name": "Path 2648",
    d: "M-2020.62,4883.26s-9.64,3.355-12.794,9.846c-7.764,15.981-22.254,39.674-23.689,40.235,0,0,15.925,5.535,25.063,2.62,0,0-17.874,13.629-21.6,17.243,0,0,24.318,30.8,34.21,42.511s26.809,71.4,28.526,84.487c0,0-2.718-43.572-5.945-68.335s-9.963-41.526-17.878-71.91C-2019.92,4920.06-2030.17,4888.93-2020.62,4883.26Z",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2649",
    "data-name": "Path 2649",
    d: "M-1933.58,4882.58s10.557,3.844,13.24,10.618c6.548,16.515,21.579,40.072,23.007,40.661,0,0-16.027,5.24-25.11,2.16,0,0,17.621,13.954,21.281,17.636,0,0-28.11,32.964-38.217,44.493s-21.384,69.2-22.651,80.362a398.129,398.129,0,0,1,3.014-67.242c3.4-24.737,10.717-41.333,19.192-71.568C-1934.28,4919.91-1924.14,4888.44-1933.58,4882.58Z",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2650",
    "data-name": "Path 2650",
    d: "M-1846.87,5224.91l4.189,45.844h3.276Z",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    d: "M-2097.27,5218.95l-6.959,51.8h4.19Z",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M-1848.38,5214.99s-35.585,6.721-71.176,8.449c0,0,2,23.1,4.564,47.315h75.943C-1843.67,5243.96-1848.38,5214.99-1848.38,5214.99Z",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M-1919.55,5223.44s39.469-.5,71.176-8.449C-1848.38,5214.99-1908.85,5220.21-1919.55,5223.44Z",
    fill: "url(#linear-gradient-52)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M-2025.59,5222.9c-31.644,1.382-71.354-6.781-71.354-6.781s-4.858,28.128-8.819,54.629h76.682C-2027.06,5246.33-2025.59,5222.9-2025.59,5222.9Z",
    fill: "url(#linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M-2096.94,5216.12s35.49,7.32,71.354,6.781C-2025.59,5222.9-2074.05,5216.33-2096.94,5216.12Z",
    fill: "url(#linear-gradient-54)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M-1938.29,4876.02c.034-.106.056-.18.056-.18Z",
    fill: "url(#linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M-2052.19,4802.11c-7.4,1.384-5.774,6.49-2.538,15.427,3.142,23.754,9.18,28.5,11.743,27.049C-2038.3,4841.94-2043.23,4800.44-2052.19,4802.11Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M-2046.21,4835.92s-3.461-4.447-2.078-12.793c3.261-19.69-8.66-21.653-6.374-7.984,0,0,1.86-6.3,3.313-4.314,1.787,2.437-2.109,3.537-.474,13.864C-2050.96,4830.07-2046.21,4835.92-2046.21,4835.92Z",
    fill: "url(#linear-gradient-56)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M-1912.8,4801.94c7.465,1.033,6.132,6.21,3.406,15.285-1.792,23.868-7.552,28.891-10.2,27.565C-1924.41,4842.36-1921.84,4800.69-1912.8,4801.94Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M-1916.86,4835.98s3.206-4.6,1.353-12.875c-4.369-19.509,7.419-22.028,5.913-8.273,0,0-2.213-6.2-3.556-4.149-1.645,2.514,2.307,3.43,1.263,13.822C-1912.44,4829.91-1916.86,4835.98-1916.86,4835.98Z",
    fill: "url(#linear-gradient-57)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M-1918.61,4800.77c2.207-55.883-14.717-63.413-19.538-69.115-9.817-11.589-25.24-16.647-51.611-16.024,0,0-34.35,1.227-42.937,20.276-9.185,20.367-10.824,48.378-10.017,74.637.98,31.88.972,40.322,3.718,47a26.36,26.36,0,0,0,8.975,12.244c9.774,7.824,22.633,22.549,30.542,28.984,3.19,2.6,24.547,8.138,41.339-3.39,8.8-6.044,17.97-13.707,28.691-24.563,4.742-4.8,7.813-12.61,7.813-16.514,0-4.473,2.087-26.742,1.924-30.071C-1920.59,4806.23-1919.22,4816.3-1918.61,4800.77Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2662",
    "data-name": "Path 2662",
    d: "M-1966.33,4787.39c-.835,5.435-7.132,25.674-3.981,27.559,19.69,11.742,42.241-3.5,42.241-3.5C-1929.56,4775.74-1966.33,4787.39-1966.33,4787.39Z",
    fill: "url(#linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2663",
    "data-name": "Path 2663",
    d: "M-2034.41,4812.3s20.909,14.151,41.037,1.043c3.081-2.01-2.994-19.781-3.844-25.217C-1997.22,4788.13-2034.87,4776.9-2034.41,4812.3Z",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M-1945.44,4853.6c10.852.739,23.031-.819,25.3-23.622,1.3-12.993-.127-19.615-5.494-20.632-11.392-2.163-27.725,2.894-34.527,6.49C-1974.53,4823.43-1964.67,4852.29-1945.44,4853.6Z",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M-2005.48,4814.75c-11.4-4.238-22.664-7.814-33.761-4.525-4.016,1.188-4.092,10.5-3.421,19.19.321,4.169,0,10.693.925,13.313,4.547,12.858,23.908,13.424,33.912,9.837C-1990.75,4846.44-1989.75,4820.57-2005.48,4814.75Z",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    "data-name": "Path 2666",
    d: "M-1926.91,4815.58c-1.96-1.113-3.414.5-7.482,1.857-3.992,1.33-14.893,3.417-9.767,6.238,5.662,3.122,13.578-1.154,14.537-1.957S-1924.49,4816.96-1926.91,4815.58Z",
    fill: "url(#linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M-1953.54,4861.3c-.411.349-.814.7-1.195,1.034A10.04,10.04,0,0,0-1953.54,4861.3Z",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M-1958.47,4840.8c12.709,10.409,7.564,17.879,4.926,20.5,4.889-4.149,11.481-8.779,11.048-10.6C-1944.07,4844.07-1958.47,4840.8-1958.47,4840.8Z",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M-1954.85,4853.48s6.521-1.535,7.1-2a6.293,6.293,0,0,0,1.1-2.152l-4.143,1.276Z",
    fill: "#e1b18c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M-2017.25,4851.7c.29,2.035,5.968,7.046,9.694,10.95,0,0-9.948-10.831,3.887-20.588C-2003.67,4842.07-2018.23,4844.87-2017.25,4851.7Z",
    fill: "url(#linear-gradient-63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M-2013.86,4849.74a6.282,6.282,0,0,0,1.1,2.152c.575.471,7.1,2.006,7.1,2.006l-4.05-2.882Z",
    fill: "#e1b18c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M-1993.47,4878.52c17.276-1.937,28.946.223,28.946.223C-1977.63,4870.49-1993.47,4878.52-1993.47,4878.52Z",
    fill: "url(#linear-gradient-64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    d: "M-2012.31,4850.56c.352.369.606.875,1.063,1.079,8.294,3.72,8.41,7.271,11.966,9.215,12.608,6.881,27.309,5.209,37.208-.321,5.692-3.181,6.42-6.888,13.232-9.578a1.738,1.738,0,0,0,1.089-1.081C-1984.15,4858.89-2012.31,4850.56-2012.31,4850.56Z",
    fill: "#96282d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M-1979.7,4868.11c-4.908,0-9.754-.971-9.754,0s4.266,3.132,9.177,3.13,9.761-2.161,9.761-3.132S-1974.79,4868.11-1979.7,4868.11Z",
    fill: "#fdd8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M-1965.54,4858.23a80.814,80.814,0,0,1-15.384,1.957,92.252,92.252,0,0,1-16.307-1.822c-1.536-.283-2.2,2.433-2.2,2.433,4.623,3.416,10.189,4.711,19.081,4.774,11.878.083,18.43-5.121,18.43-5.121S-1963.58,4857.83-1965.54,4858.23Z",
    fill: "url(#linear-gradient-65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M-1997.83,4869.37c18.953,15.264,37.085-1.043,37.085-1.043C-1979.9,4878.64-1997.83,4869.37-1997.83,4869.37Z",
    fill: "url(#linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M-2004.08,4852.32a5.471,5.471,0,0,0,3.289,4.54c1.839.8,5.955,3.974,21.97,3.479s19.171-4.411,19.9-5.1a8.649,8.649,0,0,0,1.976-3.426S-1981.06,4856.6-2004.08,4852.32Z",
    fill: "url(#linear-gradient-67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M-2004.14,4852.02a6.175,6.175,0,0,0,.626,2.282c.44.707,13.23,2.6,22.892,2.657s22.268-2.462,22.712-3.024a7.652,7.652,0,0,0,1.077-2.435S-1967.7,4855.2-2004.14,4852.02Z",
    fill: "#f3eceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M-2014.29,4849.56s2.327,1.367,1.975,1c0,0,28.165,8.327,64.558-.686l1.973-1C-1965.55,4852.22-2014.29,4849.56-2014.29,4849.56Z",
    fill: "url(#linear-gradient-68)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M-2030.18,4817.91c-4.13-1.146-5.665-2.681-7.564-1.466-2.343,1.5,2.019,5.235,3.018,5.987s9.12,4.611,14.614,1.2C-2015.14,4820.54-2026.13,4819.03-2030.18,4817.91Z",
    fill: "url(#linear-gradient-69)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    d: "M-1951.7,4801.49c-5.776.32-13.537,1.715-15.846,11.291-.963,3.99,11.149,5.775,18.279,5.217,9.529-.738,14.393-8.489,13.889-9.481C-1938.95,4801.49-1948.41,4801.31-1951.7,4801.49Z",
    fill: "url(#linear-gradient-70)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M-1958.39,4803.21c-3.737.454-4.874,1.9-5.648,2.933a17.6,17.6,0,0,0-2.54,6.017c-.046.77,1.929,2.487,3.714,2.852,4.186.856,7.316,2.251,17.136.368,3.058-.586,7.1-4.026,7.958-5.344a5.937,5.937,0,0,0,.94-2.412C-1941.91,4802.48-1943.09,4801.35-1958.39,4803.21Z",
    fill: "url(#linear-gradient-71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    d: "M-1945.84,4802.52c-4.481.5-14.666-.722-19.9,6.879,3.834-1.781,13.2-3.075,28.038.532a5.892,5.892,0,0,0,.878-2.312S-1940.13,4801.9-1945.84,4802.52Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M-1952.78,4802.49c-5.935-.3-9.41,3.621-9.118,8.742a10.256,10.256,0,0,0,1.387,4.31,26.479,26.479,0,0,0,7.608.779,32.008,32.008,0,0,0,7.172-.938c.909-.25,1.449-2.7,1.458-3.77C-1944.21,4804.54-1947.79,4802.74-1952.78,4802.49Z",
    fill: "url(#linear-gradient-72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M-1952.4,4801.83a8.642,8.642,0,0,0-9.182,6.351,48.648,48.648,0,0,1,17.06.36,7.856,7.856,0,0,0-7.878-6.711Z",
    fill: "url(#linear-gradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    d: "M-1952.94,4803.93a5.324,5.324,0,0,0-3.805,1.469,5.323,5.323,0,0,0-1.648,3.731,5.366,5.366,0,0,0,5.3,5.4,5.336,5.336,0,0,0,5.456-5.214,5.353,5.353,0,0,0-5.3-5.385Z",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2687",
    "data-name": "Path 2687",
    d: "M-1943.31,4802.23c-4.327-1.845-14.648-.939-17.022.246-4.009,2-5.412,6.928-5.412,6.928s4.005-4.969,15.524-4.6c9.123.295,13.392,2.815,13.392,2.815S-1938.08,4804.46-1943.31,4802.23Z",
    fill: "url(#linear-gradient-74)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M-1948.54,4809.4a2.4,2.4,0,0,0-2.037,2.659,2.3,2.3,0,0,0,.839,1.578,2.3,2.3,0,0,0,1.715.5,2.382,2.382,0,0,0,2.037-2.658,2.3,2.3,0,0,0-.839-1.578A2.3,2.3,0,0,0-1948.54,4809.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2689",
    "data-name": "Path 2689",
    d: "M-1953.58,4807.21a1.874,1.874,0,0,0-1.606,2.085,1.847,1.847,0,0,0,.671,1.245,1.844,1.844,0,0,0,1.355.4,1.87,1.87,0,0,0,1.6-2.084,1.837,1.837,0,0,0-.667-1.246,1.834,1.834,0,0,0-1.354-.4Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2690",
    "data-name": "Path 2690",
    d: "M-2012.22,4801.76c-3.292-.185-12.748-.007-16.321,7.027-.5.992,4.36,8.743,13.889,9.481,7.13.558,19.241-1.227,18.28-5.217C-1998.68,4803.48-2006.44,4802.08-2012.22,4801.76Z",
    fill: "url(#linear-gradient-75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2691",
    "data-name": "Path 2691",
    d: "M-2005.53,4803.48c-15.294-1.854-16.475-.733-21.56,4.413a5.931,5.931,0,0,0,.94,2.412c.856,1.318,4.9,4.758,7.957,5.344,9.821,1.883,12.952.489,17.137-.368,1.785-.365,3.76-2.081,3.714-2.852a17.6,17.6,0,0,0-2.54-6.017C-2000.66,4805.38-2001.8,4803.93-2005.53,4803.48Z",
    fill: "url(#linear-gradient-76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2692",
    "data-name": "Path 2692",
    d: "M-2018.08,4802.79c-5.711-.63-9.012,5.1-9.012,5.1a4.656,4.656,0,0,0,.877,2.313c14.844-3.607,24.2-2.313,28.039-.533C-2003.42,4802.07-2013.6,4803.29-2018.08,4802.79Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2693",
    "data-name": "Path 2693",
    d: "M-2011.15,4802.75c-4.982.251-8.566,2.055-8.507,9.123.009,1.069.967,3.53,1.457,3.77a24.954,24.954,0,0,0,7.173.938,26.479,26.479,0,0,0,7.608-.779,10.254,10.254,0,0,0,1.387-4.31C-2001.74,4806.38-2005.21,4802.46-2011.15,4802.75Z",
    fill: "url(#linear-gradient-77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2694",
    "data-name": "Path 2694",
    d: "M-2011.52,4802.1a7.855,7.855,0,0,0-7.878,6.711,48.66,48.66,0,0,1,17.06-.36,8.643,8.643,0,0,0-9.182-6.352Z",
    fill: "url(#linear-gradient-78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2695",
    "data-name": "Path 2695",
    d: "M-2010.99,4804.2a5.352,5.352,0,0,0-5.3,5.393,5.335,5.335,0,0,0,5.456,5.214,5.365,5.365,0,0,0,5.3-5.4,5.32,5.32,0,0,0-1.646-3.737,5.322,5.322,0,0,0-3.81-1.47Z",
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2696",
    "data-name": "Path 2696",
    d: "M-2003.59,4802.75c-2.375-1.186-12.7-2.092-17.022-.247-5.233,2.231-6.482,5.393-6.482,5.393s4.269-2.52,13.392-2.815c11.518-.373,15.524,4.6,15.524,4.6S-1999.58,4804.75-2003.59,4802.75Z",
    fill: "url(#linear-gradient-79)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    d: "M-2006.86,4809.68a2.4,2.4,0,0,0-2.037,2.659,2.3,2.3,0,0,0,.839,1.578,2.3,2.3,0,0,0,1.715.5,2.383,2.383,0,0,0,2.037-2.658,2.3,2.3,0,0,0-.839-1.578,2.3,2.3,0,0,0-1.715-.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2698",
    "data-name": "Path 2698",
    d: "M-2011.9,4807.49a1.873,1.873,0,0,0-1.606,2.084,1.848,1.848,0,0,0,.671,1.246,1.845,1.845,0,0,0,1.356.4,1.871,1.871,0,0,0,1.6-2.084,1.84,1.84,0,0,0-.667-1.246A1.84,1.84,0,0,0-2011.9,4807.49Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    d: "M-1966.69,4785.72c-.384,3.233-.617,6.309,1.355,6.3,7.2-.025,33.26-.942,33.26-.942s-6.893-4.646-9.793-5.762C-1945.59,4783.89-1957.72,4784.21-1966.69,4785.72Z",
    fill: "url(#linear-gradient-80)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    "data-name": "Path 2700",
    d: "M-2021.58,4785.59c-2.9,1.117-9.793,5.762-9.793,5.762s26.062.917,33.259.942c1.972.007,1.74-3.068,1.356-6.3C-2005.74,4784.48-2017.86,4784.16-2021.58,4785.59Z",
    fill: "url(#linear-gradient-80)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    d: "M-2043.41,4817.58c.456,12.28,1.169,31.933,2.793,37.753a29,29,0,0,0,7.842,13.556c9.53,9.021,22.368,19.576,22.368,19.576-1.867-2.759-17.707-21.223-20.535-25.506C-2041.71,4846.65-2043.41,4817.58-2043.41,4817.58Z",
    fill: "url(#linear-gradient-82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    d: "M-1951.4,4890.47c4.022-3.187,13.877-11.388,22.239-19.459,3.972-3.834,6.51-10.6,7.643-15.067s1.8-31.719,1.8-31.719c-1.2,11.178-3.589,28.586-9.439,39.253S-1949.1,4887.38-1951.4,4890.47Z",
    fill: "url(#linear-gradient-83)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    d: "M-1975.73,4816.03c.624-12.354-3.7-14.125-6.9-14.015-3.114.109-4.835,4.389-4.2,13.811.627,9.385-1.209,12.983-.789,17.38.2,2,1.121,3.311,6.194,3.351,5.572.041,7.507-1.277,7.745-3.146C-1973.03,4828.29-1976.19,4824.94-1975.73,4816.03Z",
    fill: "url(#linear-gradient-84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2704",
    "data-name": "Path 2704",
    d: "M-1996.43,4838.06s13.993,10.17,17.042,9.573,14.277-9.573,14.277-9.573-12.693,1.561-15.611,1.561S-1996.43,4838.06-1996.43,4838.06Z",
    fill: "url(#linear-gradient-85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    "data-name": "Path 2705",
    d: "M-1975.12,4840.06c7.533-1.869,10.495-.759,10.495-.759C-1969.01,4835.45-1975.12,4840.06-1975.12,4840.06Z",
    fill: "#e1b18c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    "data-name": "Path 2706",
    d: "M-1996.46,4838.75s3.906-.632,9.826,1.372C-1986.64,4840.12-1992.41,4835.75-1996.46,4838.75Z",
    fill: "#e1b18c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    "data-name": "Path 2707",
    d: "M-1969.3,4827.53c-.049,3.089.666,5.155-.275,6.918-2.093,3.92-7.518,5.475-11.146,5.18-2.748.332-9.188-1.044-11.867-5.155-1.093-1.677-.406-3.178-.9-6.464,0,0-7.456,9-2.98,10.745,0,0,1.31-.983,4.912-.658s2.86,4.287,11.133,4.366c7.211.066,4.909-3.389,9.5-4.044s5.178.525,6.218.981C-1962.41,4839.4-1964.06,4831.78-1969.3,4827.53Z",
    fill: "url(#linear-gradient-86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    d: "M-1988.42,4832.82c-.315,2.013,2.515,4.178,7.588,4.218,5.571.042,6.817-2.161,6.352-4.012C-1977.23,4822.06-1987.25,4825.33-1988.42,4832.82Z",
    fill: "url(#linear-gradient-87)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    "data-name": "Path 2709",
    d: "M-1935.12,4740.86c-24.113-17.116-88.672-.272-95.272-.113S-2042.3,4824.2-2042.3,4824.2s5.07-16.608,7.433-26.735,3.339-34.169,11.835-42.6c24.6-24.429,68.291-14.027,78.8-4.234,11.285,10.517,13.329,36.928,15.614,43.13s8.8,28.277,8.8,28.277S-1911.01,4757.98-1935.12,4740.86Z",
    fill: "url(#linear-gradient-88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    "data-name": "Path 2710",
    d: "M-1927.8,4724.05s4.561,1.166,14.245,5.83c0,0-17.29-27.69-54.876-29.731-19.657-1.067-48.107,2.041-57.318,19.529,0,0-14.506-11.087-25.627,15.874a16.289,16.289,0,0,1,12.979-5.773s-14.29,3.018-17.792,29.151c-1.377,10.274.858,26.263,3.281,43.335,0,0,9.071-.386,10.207,22.563,0,0,3.657-30.458,6.821-46.2,0,0,2.356,8.773,1.461,14.666,1.66-2.811,9.889-10.507,9.819-52.735,0,0,8.884,39.5,56.72,29.256,0,0-8.978-1.725-11.508-8.234,13.882,11.016,32.649,16.969,50.909,20.155l-5.654-18.587s12.149,22.422,12.911,42.277c.2,5.339,1.505,18.8,1.505,18.8s.149-22,8.429-22c0,0,2.09-23.6-.824-35.3a18.973,18.973,0,0,1,4.343,8.962S-1902.53,4745.28-1927.8,4724.05Z",
    fill: "url(#linear-gradient-89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    "data-name": "Path 2711",
    d: "M-1919.71,4824.23s8.081-36.016-13.584-64.328C-1933.3,4759.9-1921.98,4786.39-1919.71,4824.23Z",
    fill: "#1e1412"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    "data-name": "Path 2712",
    d: "M-2017.3,4759.06a75.34,75.34,0,0,1-8.342-24.624c-.129,5.8-.7,13.613,1.137,19.093,1.7,5.073,3.866,10.58,7.421,14.632,5.944,6.774,15.551,8.41,24.081,8.616-4.807-1.685-9.716-3.392-14.078-6.091C-2011.3,4768.07-2014.91,4763.38-2017.3,4759.06Z",
    fill: "#1e1412"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2713",
    "data-name": "Path 2713",
    d: "M-1999.37,4764.72c-4.573-2.387-9.5-4.959-13.379-8.413-3.641-3.241-10.607-12.733-12.89-19.187,1.142,8.163,1.917,13.181,5.7,18.286a37.266,37.266,0,0,0,12.14,10.466c4.848,2.725,9.687,5.074,15.217,5.941a64.921,64.921,0,0,0,25.209-1,109.732,109.732,0,0,1-17.491-1.669A49.419,49.419,0,0,1-1999.37,4764.72Z",
    fill: "#1e1412"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2714",
    "data-name": "Path 2714",
    d: "M-1951.19,4775.54c-5.167-2.007-9.734-4.295-13.825-6.295-8.149-4.024-14.121-7.434-18.6-10.185s-7.481-4.764-9.442-6.01a25.37,25.37,0,0,0-2.9-1.678c5.165,7.686,12.475,13.618,19.762,17.84a93.063,93.063,0,0,0,10.854,5.394,88,88,0,0,0,10.191,3.662,42.92,42.92,0,0,0,15.844,1.84,27.989,27.989,0,0,0,4.266-.734l1.449-.415C-1940.15,4779.23-1946.02,4777.5-1951.19,4775.54Z",
    fill: "#1e1412"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2715",
    "data-name": "Path 2715",
    d: "M-1935.91,4775.74c-2.673-1.612-5.238-3.4-7.88-5.059-2.088-1.315-4.422-2.892-6.863-3.426,6.612,11.647,22.162,22.3,35.288,14.408C-1922.71,4782.43-1929.72,4779.47-1935.91,4775.74Z",
    fill: "#1e1412"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    d: "M-2043.03,4802.35a92.886,92.886,0,0,0,.446,23.219s6.622-30.993,6.622-50.433c0-2.963-1.99-9.563-3.822-11.984C-2041.57,4776.08-2042.47,4789.27-2043.03,4802.35Z",
    fill: "#1e1412"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M-1934.13,4762.88c3.33,7.166,4.156,8.29,5.488,12.063,1.3,3.677,2.238,7.466,3.321,11.211,1.846,6.382,4.146,12.716,9.215,17.188-3.768-7.735-3.46-16.641-6.047-24.741C-1923.99,4772.85-1929.61,4766.86-1934.13,4762.88Z",
    fill: "#1e1412"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M-2025.83,4738.25c.38,11.28.674,19.73-2.544,33.067a111.226,111.226,0,0,1-10.664,27.654,47.078,47.078,0,0,0,9.433-12.986c4.136-8.34,7.236-18.5,6.788-27.812C-2023,4754.26-2024.5,4747.3-2025.83,4738.25Z",
    fill: "#1e1412"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    d: "M-1926.85,4724.23c7.869,3.148,13.3,5.645,13.3,5.645s-16.214-28.061-56.812-31.188c-45.412-3.5-55.382,20.986-55.382,20.986-24.835-5.85-37.415,25.106-34.835,54.052,8.762-35.749,36.371-46.039,36.371-46.039,1.246,19.529,41.548,20.153,41.548,20.153a23.237,23.237,0,0,1-5.064-17.333c8.724,16.767,54.061,19.738,54.061,19.738-9.579-13.1-15.985-20.111-15.985-20.111,24.754,7.662,41.884,45.759,41.884,45.759C-1903.63,4736.51-1926.85,4724.23-1926.85,4724.23Z",
    fill: "url(#linear-gradient-90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    d: "M-1984.16,4698.45c-9.676-.186-20.367,1.576-28.9,6.443,8.658-9.486,21.814-11.2,33.766-12.948-10.054-1.36-20.867-1.546-30.041,3.48a28.638,28.638,0,0,0-9.994,9.252c-2.511,3.744-4.908,8.432-5.459,12.977-6.321-5.69-17.126-4.725-23.208.694-5.747,5.12-11.4,17.187-11.4,22.212,4.436-10.453,8.691-14.27,14.737-17.288,6.992-3.49,13.853-3.8,20.152-1.406.043.257,2.168-.4,2.168-.4a22.381,22.381,0,0,1,1.761-4.431,29.146,29.146,0,0,1,6.567-6.675,31.825,31.825,0,0,1,8.813-3.644,77.643,77.643,0,0,1,10.214-2.33,84.32,84.32,0,0,1,38.159,2.976,95.955,95.955,0,0,1,15.7,6.826,72.554,72.554,0,0,0-11.931-7.83A69.907,69.907,0,0,0-1984.16,4698.45Z",
    fill: "url(#linear-gradient-91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2721",
    "data-name": "Path 2721",
    d: "M-1980.01,4882.96c-3.769.015-13.214,2.567-12.94,3.948.828,4.179,9.574,4.879,13.341,4.861s11.4-.975,11.557-4.542C-1967.99,4885.83-1976.24,4882.94-1980.01,4882.96Z",
    fill: "url(#linear-gradient-92)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2722",
    "data-name": "Path 2722",
    d: "M-1979.63,4878.74c-9.667,0-17.5,3.291-17.695,5.768-.367,4.732,7.313,5.922,14.7,6.743s18.619-3.237,18.619-6.743S-1966.47,4878.74-1979.63,4878.74Z",
    fill: "url(#linear-gradient-93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2723",
    "data-name": "Path 2723",
    d: "M-1995.19,4899.39c-4.308-1.142-15.218-10.927-15.218-10.927s9.358,12.846,14.8,13.952,21.52,1.793,28.034,0,17.838-13.269,17.838-13.269-11.019,7.54-17.31,10.244S-1990.88,4900.53-1995.19,4899.39Z",
    fill: "url(#linear-gradient-94)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 187.603,
    cy: 20.978,
    rx: 187.603,
    ry: 20.978,
    transform: "translate(-2150.881 5948.086)",
    fill: "url(#radial-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2724",
    "data-name": "Path 2724",
    d: "M-2003.3,5197.29l-2.976,70.426,80.742,1.984-11.505-68.442Z",
    fill: "url(#linear-gradient-95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    d: "M-1947.95,5242.52l2.282,20.334,12,.5-1.19-23.211Z",
    fill: "#b8cff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    d: "M-2002.11,5233.59l-4.761,33.923,11.507,1.289,2.777-34.32Z",
    fill: "#b8cff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2727",
    "data-name": "Path 2727",
    d: "M-2003.9,5260.38s50.588,1.19,68.442-4.167l1.786,7.142s-32.734,9.523-71.419,3.571Z",
    fill: "#b8cff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2728",
    "data-name": "Path 2728",
    d: "M-1968.19,5400.24l-19.937,99.092,49.695-.3Z",
    fill: "url(#linear-gradient-96)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2729",
    "data-name": "Path 2729",
    d: "M-2106.77,5907.65s.648,11.2-1.3,16.511c-2.875,7.838-27.392,35.42-27.95,42.515-.959,12.239,4.456,11.088,4.456,11.088s22.976,3.651,41.374,2.609c12.344-.7,21.973-5.375,22.954-6.847a134.939,134.939,0,0,0,6.641-11.936l16.443-2.423s.229-18.448-1.915-19.476l-4.741-25.078S-2102.57,5904.91-2106.77,5907.65Z",
    fill: "url(#linear-gradient-97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2730",
    "data-name": "Path 2730",
    d: "M-2060.63,5961.6s.445-14.964,7.353-18.373c4.363-2.153,5.479-2.6,7.174-3.622,2.361,1.276,2.009,19.6,2.009,19.6S-2048.18,5959.9-2060.63,5961.6Z",
    fill: "url(#linear-gradient-98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2731",
    "data-name": "Path 2731",
    d: "M-2134.14,5976.81s52.493,7.487,66.936-3.314c0,0-4.7,8.539-31.318,9.242C-2128.03,5983.51-2134.14,5976.81-2134.14,5976.81Z",
    fill: "url(#linear-gradient-99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2732",
    "data-name": "Path 2732",
    d: "M-2119.17,5963.79s26.753.806,41.69-6.817,11.7,18.006-9.447,17.835S-2144.35,5962.15-2119.17,5963.79Z",
    fill: "url(#linear-gradient-100)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2733",
    "data-name": "Path 2733",
    d: "M-1829.8,5907.65s-.648,11.2,1.3,16.511c2.874,7.838,27.391,35.42,27.949,42.515.96,12.239-4.455,11.088-4.455,11.088s-22.974,3.651-41.372,2.609c-12.345-.7-21.974-5.375-22.955-6.847a135.035,135.035,0,0,1-6.645-11.936l-16.441-2.423s-.229-18.448,1.918-19.476l4.741-25.078S-1834.01,5904.91-1829.8,5907.65Z",
    fill: "url(#linear-gradient-101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2734",
    "data-name": "Path 2734",
    d: "M-1875.94,5961.6s-.444-14.964-7.353-18.373c-4.361-2.153-5.478-2.6-7.17-3.622-2.362,1.276-2.013,19.6-2.013,19.6S-1888.39,5959.9-1875.94,5961.6Z",
    fill: "url(#linear-gradient-102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2735",
    "data-name": "Path 2735",
    d: "M-1802.43,5976.81s-52.49,7.487-66.934-3.314c0,0,4.693,8.539,31.315,9.242C-1808.55,5983.51-1802.43,5976.81-1802.43,5976.81Z",
    fill: "url(#linear-gradient-103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2736",
    "data-name": "Path 2736",
    d: "M-1817.41,5963.79s-26.754.806-41.69-6.817-11.7,18.006,9.446,17.835S-1792.23,5962.15-1817.41,5963.79Z",
    fill: "url(#linear-gradient-104)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2737",
    "data-name": "Path 2737",
    d: "M-2096.5,5372.11l-4.785,317.437-2.791,165.5-8.294,23.335,5.365,38.882c8.541-.056,15.223-.634,32.639,1.346-13.929-3.454-23.072-5.739-23.072-5.739s12.4-74.667,18.78-104.974,7.681-205.018,7.681-211.4,35.626-253.629,49.982-312.65a120.748,120.748,0,0,1,6.63-20.13c-21.44-.865-42.839-3.1-64.458-5.813Z",
    fill: "url(#linear-gradient-105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2738",
    "data-name": "Path 2738",
    d: "M-1838.08,5743.78l-1.594-119.637-1.6-256.819-31.013-109.841c-25.366,2.078-50.048,3.555-75.471,5.074l41.082,115.932s22.864,197.269,22.864,214.813,8.122,160.456,9.716,173.217,19.027,148.25,19.027,148.25-15.432,8.07-34.181,16.819l.121.42s27.119-9.571,35.094-12.761,25.4,3.311,25.4,3.311l3.316-33.619-1.6-38.285Z",
    fill: "url(#linear-gradient-106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2739",
    "data-name": "Path 2739",
    d: "M-2019.97,5260.38c-2.84,5.457-3.879,14.971-5.687,22.4-14.356,59.02-47.854,306.269-47.854,312.649s-4.785,175.468-11.165,205.775S-2098,5917.14-2098,5917.14s11.429.567,26.5,1.845c15.3,1.739,22.441,3.639,22.441,3.639a226.886,226.886,0,0,1,11.59-24.114c6.378-11.165,6.378-31.9,6.378-31.9l7.976-47.853,7.977-164.3s22.394-122.829,25.584-127.615,23.863-105.919,23.863-105.919c22.334,73.375,36.69,196.843,36.69,196.843l11.167,140.376,17.547,73.377-3.191,36.689-1.593,17.544,7.974,19.144,8,27.244c19.345-6.638,35.787-13.138,35.787-13.138s-6.448-141.72-8.042-154.481-20.737-154.731-20.737-172.278-14.355-216.941-14.355-216.941l-37.226-114.921C-1937.55,5260.6-1978.9,5267.52-2019.97,5260.38Z",
    fill: "url(#linear-gradient-107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2740",
    "data-name": "Path 2740",
    d: "M-2015.14,5654.45s28.18-133.462,29.774-136.12,19.673-93.583,19.673-93.583,26.181,123.658,27.245,133.759,10.854,71.763,14.474,122.357c0,0,1.352-134.352.288-140.2s-40.942-146.224-40.942-146.224-18.078,38.284-20.206,49.983S-2015.14,5654.45-2015.14,5654.45Z",
    fill: "url(#linear-gradient-108)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2741",
    "data-name": "Path 2741",
    d: "M-1907.03,5261.75c-17.35,1.566-36.379,2.706-50.447,3.916-30.025,2.582-91.483-7.236-91.483-7.236l-2.136,20.01s6.749,8.263,73.926,11.44c23.005,1.088,51.994-2.24,75.877-5.983C-1903.6,5275.53-1907.12,5262.76-1907.03,5261.75Z",
    fill: "url(#linear-gradient-109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2742",
    "data-name": "Path 2742",
    d: "M-1956.46,5285.33a13.328,13.328,0,0,1,.093,3.444c-.257,1.034-26.245,2.26-28.357-1.411s-1.759-18.522.055-20.782,27.968-2.866,28.3-1.248a24.788,24.788,0,0,1,0,3.407s-22.233-.191-23.738.848-.934,5.017-.934,5.017,7.485.665,8.382,1.179.159,2.694.007,3.613-8.472,1.112-8.472,1.112-.615,3.906.715,4.859S-1956.46,5285.33-1956.46,5285.33Z",
    fill: "url(#linear-gradient-110)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2743",
    "data-name": "Path 2743",
    d: "M-1957.2,5285.18a13.269,13.269,0,0,1,.093,3.444c-.257,1.034-26.245,2.26-28.357-1.411s-1.759-18.522.055-20.781,27.968-2.867,28.3-1.249a24.822,24.822,0,0,1,0,3.408s-22.233-.191-23.738.848-.934,6.207-.934,6.207l8.382-.012.007,3.613-8.472-.078s-.615,5.1.715,6.049S-1957.2,5285.18-1957.2,5285.18Z",
    fill: "url(#linear-gradient-111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2744",
    "data-name": "Path 2744",
    d: "M-1945.8,5261.79l22.443,236.846h28.171l-34.507-238.873Z",
    fill: "url(#linear-gradient-112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2745",
    "data-name": "Path 2745",
    d: "M-2006.87,5262.16l11.847,1.023-20.773,235.053-25.79-1.19Z",
    fill: "url(#linear-gradient-113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2746",
    "data-name": "Path 2746",
    d: "M-1949.14,5206.22l98.73-2.381s36.17,231.315,44.652,276.655c-45.778,23.3-111.244,23.3-111.244,23.3Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2747",
    "data-name": "Path 2747",
    d: "M-1993.19,5209.79l-103.18-3.574s-32.118,240.047-36.962,275.723c40.157,19.475,112.765,21.855,112.765,21.855Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2748",
    "data-name": "Path 2748",
    d: "M-1990.51,5191.12l-102.747,4.6-4.976,24.7s44.669,6.072,55.4,10.16c6.263,2.386,32.389,12.735,46.078,17.5Z",
    fill: "url(#linear-gradient-114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2749",
    "data-name": "Path 2749",
    d: "M-1852.8,5184.79l-99.514,2.779c.992,7.538,3.471,20.209,4.29,28.839l12.979-7.773s62.766,7.7,86.262,5.652Z",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2750",
    "data-name": "Path 2750",
    d: "M-1980.69,5294.3s-2.381,62.491,2.976,68.442,16.068,7.737,16.068,7.737-10.117-5.356-12.5-10.712S-1980.69,5294.3-1980.69,5294.3Z",
    fill: "url(#linear-gradient-116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2751",
    "data-name": "Path 2751",
    d: "M-1840.83,5265.14l20.273,221.879s11.326-4.333,14.792-6.525Z",
    fill: "url(#linear-gradient-117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2752",
    "data-name": "Path 2752",
    d: "M-2103.36,5258.89l-29.965,223.049s9.8,4.819,17.672,6.939Z",
    fill: "url(#linear-gradient-118)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2753",
    "data-name": "Path 2753",
    d: "M-1841.4,5254.74s-37.31,7.047-74.627,8.858c0,0,9.086,105.057,13.712,106.865s73.712-7.931,77.379-10.723C-1823.59,5358.71-1841.75,5252.97-1841.4,5254.74Z",
    fill: "url(#linear-gradient-119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2754",
    "data-name": "Path 2754",
    d: "M-1917.03,5263.59s41.383-.522,74.627-8.858C-1842.4,5254.74-1905.81,5260.21-1917.03,5263.59Z",
    fill: "url(#linear-gradient-120)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2755",
    "data-name": "Path 2755",
    d: "M-2103.02,5255.93s41.636,8.559,74.813,7.109c0,0-6.622,105.241-11.2,107.157s-73.877-6.2-77.609-8.908S-2103.02,5255.93-2103.02,5255.93Z",
    fill: "url(#linear-gradient-121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2756",
    "data-name": "Path 2756",
    d: "M-2103.02,5255.93s37.211,7.675,74.813,7.109C-2028.21,5263.04-2079.02,5256.14-2103.02,5255.93Z",
    fill: "url(#linear-gradient-122)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctors06);
export default __webpack_public_path__ + "static/media/Doctors 06.c3ef4c2bcc5ea1cbda95d5d886f95b34.svg";
export { ForwardRef as ReactComponent };